import { FILE_ATTACH_ITEMS_PAGE_COUNT } from './FileAttachItemsModal.constants'

export function getAttachItemsApiParams({ ordering, page, parent }) {
  return { ordering, page, parent }
}

export function parseAttachItemPaginationData(data) {
  return {
    count: data.count,
    pageCount: data.pages,
    pageSize: FILE_ATTACH_ITEMS_PAGE_COUNT,
  }
}

export function isEqualFileAttachItemsModal({ selected }) {
  return selected.length === 0
}
